import api from "../api/api";
import IDealPortfolio, { IDealPortfolioState } from "../interfaces/IDealPortfolio";

export default class DealPortfolioApiService {
    public async getPortfolios(): Promise<IDealPortfolio[]> {
        const response = await api.get<IDealPortfolio[]>("/dealportfolio/get");
        return response.data;
    }

    public async createPortfolio(state: IDealPortfolioState): Promise<IDealPortfolio> {
        const response = await api.post<IDealPortfolio>("/dealportfolio/create", state);
        return response.data;
    }

    public async updatePortfolio(portfolio: IDealPortfolio): Promise<IDealPortfolio> {
        const response = await api.post<IDealPortfolio>("/dealportfolio/update", portfolio);
        return response.data;
    }

    public async deletePortfolio(id: number): Promise<void> {
        await api.delete(`/dealportfolio/delete?id=${id}`);
    }
}
